import { render, staticRenderFns } from "./servicePrice.vue?vue&type=template&id=1ba84d39&"
import script from "./servicePrice.vue?vue&type=script&lang=js&"
export * from "./servicePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports